import { Box, Button, IconButton, Typography } from '@mui/material';
import Container from '../../components/LandingPage/Container';
import { Instagram, LinkedIn, WhatsApp } from '@mui/icons-material';

const Footer: React.FC = () => {
  return (
    <Container>
      <Box display="flex" flexDirection="row" justifyContent="space-between" width="100%">
        <Box
          display="flex"
          flexDirection="column"
          gap="20px"
          width="100%"
          padding="28px 0"
          alignItems="center"
        >
          <Typography fontSize="16px" fontWeight="500" lineHeight="25px" letterSpacing="0.15">
            Fale com nosso consultores
          </Typography>
          <Typography
            fontSize="12px"
            fontWeight="500"
            lineHeight="25px"
            letterSpacing="0.15"
            textAlign="center"
          >
            *Imagens meramente ilustrativas. As cores, modelos e especificações de equipamentos
            variam de acordo com a região e disponibilidade.
          </Typography>
          <Box width="100%" borderTop="1px solid rgba(0, 0, 0, 0.12)"></Box>
          <Box display="flex" flexDirection="column" gap="15pxx" width="100%" alignItems="center">
            <Box
              display="flex"
              flexDirection="row"
              gap="30px"
              width="100%"
              alignItems="center"
              justifyContent="center"
            >
              <IconButton
                component="a"
                href="https://wa.me/5511988142012"
                target="_blank"
                rel="noopener noreferrer"
              >
                <WhatsApp />
              </IconButton>
              <IconButton
                component="a"
                href="https://www.linkedin.com/company/90832836/admin/page-posts/published/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <LinkedIn />
              </IconButton>
              <IconButton
                component="a"
                href="https://www.instagram.com/cisp1.io/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Instagram />
              </IconButton>
            </Box>
          </Box>
          {/* <Box display="flex" flexDirection={{ xs: 'column', sm: 'row' }} gap="15px" width="100%" alignItems="center" justifyContent="center">
                        <Button
                            variant="text"
                            color="inherit"
                            sx={{
                                fontWeight: '400',
                                '&:hover': { color: 'var(--acer-green)', bgcolor: 'transparent' },
                            }}
                        >
                            <Typography fontSize="12px" fontWeight="500" lineHeight="25px" letterSpacing="0.15">Política de Privacidade</Typography>
                        </Button>
                        <Button
                            variant="text"
                            color="inherit"
                            sx={{
                                fontWeight: '400',
                                '&:hover': { color: 'var(--acer-green)', bgcolor: 'transparent' },
                            }}
                        >
                            <Typography fontSize="12px" fontWeight="500" lineHeight="25px" letterSpacing="0.15">Política de Cookies</Typography>
                        </Button>
                        <Button
                            variant="text"
                            color="inherit"
                            sx={{
                                fontWeight: '400',
                                '&:hover': { color: 'var(--acer-green)', bgcolor: 'transparent' },
                            }}
                        >
                            <Typography fontSize="12px" fontWeight="500" lineHeight="25px" letterSpacing="0.15">Aviso Legal</Typography>
                        </Button>
                        <Button
                            variant="text"
                            color="inherit"
                            sx={{
                                fontWeight: '400',
                                '&:hover': { color: 'var(--acer-green)', bgcolor: 'transparent' },
                            }}
                        >
                            <Typography fontSize="12px" fontWeight="500" lineHeight="25px" letterSpacing="0.15">Informações legais adicionais</Typography>
                        </Button>
                        <Button
                            variant="text"
                            color="inherit"
                            sx={{
                                fontWeight: '400',
                                '&:hover': { color: 'var(--acer-green)', bgcolor: 'transparent' },
                            }}
                        >
                            <Typography fontSize="12px" fontWeight="500" lineHeight="25px" letterSpacing="0.15">Política de Acessibilidade</Typography>
                        </Button>
                    </Box> */}
        </Box>
      </Box>
    </Container>
  );
};

export default Footer;
